module.exports = __webpack_public_path__ + "static/media/arrow-left.eb50d756.svg";